

export default function UseUrlParams() {

    const updateUrlParams = (params: Record<string, any>) => {
        const searchParams = new URLSearchParams(window.location.search);
        Object.entries(params).forEach(([key, value]) => {
            if (value === null || value === undefined) {
                searchParams.delete(key);
            } else {
                searchParams.set(key, value.toString());
            }
        });
        window.history.replaceState({}, '', `${window.location.pathname}?${searchParams.toString()}`);
    }

    const removeUrlParam = (param: string) => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.delete(param);
        window.history.replaceState({}, '', `${window.location.pathname}?${searchParams.toString()}`);
    }

    const resetUrlParams = () => {
        window.history.replaceState({}, '', `${window.location.pathname}`);
    }

    return {
        updateUrlParams,
        removeUrlParam,
        resetUrlParams
    }
}